import { Color, ColorStatus } from '_helpers';

export enum ExamStatus {
    AwaitingExpertConfirmation = 'awaitingExpertConfirmation',
    IsApplying = 'isApplying',
    ApplyingFinished = 'applyingFinished',
    Canceled = 'canceled',
    IsPassing = 'isPassing',
    Finishing = 'finishing',
    Finished = 'finished',
    FinalizedResults = 'finalizedResults',
    NokProtocolSigned = 'nokProtocolSigned',
    AkProtocolSigned = 'akProtocolSigned',
    SovietProtocolSignedByMembers = 'sovietProtocolSignedByMembers',
    SovietProtocolSignedByChairman = 'sovietProtocolSignedByChairman',
}

export const MappedExamStatuses = {
    [ExamStatus.AwaitingExpertConfirmation as string]: new ColorStatus(Color.Orange, 'Идет создание'),
    [ExamStatus.IsApplying as string]: new ColorStatus(Color.Success, 'Идет запись'),
    [ExamStatus.ApplyingFinished as string]: new ColorStatus(Color.Default, 'Запись завершена'),
    [ExamStatus.IsPassing as string]: new ColorStatus(Color.Success, 'Идет сдача'),
    [ExamStatus.Canceled as string]: new ColorStatus(Color.Red, 'Отменен'),
    [ExamStatus.Finishing as string]: new ColorStatus(Color.Default, 'Завершен'),
    [ExamStatus.Finished as string]: new ColorStatus(Color.Default, 'Финализация результатов'),
    [ExamStatus.FinalizedResults as string]: new ColorStatus(Color.Default, 'Подписание протокола НОК'),
    [ExamStatus.NokProtocolSigned as string]: new ColorStatus(Color.Default, 'Подписание протокола АК'),
    [ExamStatus.AkProtocolSigned as string]: new ColorStatus(Color.Default, 'Подписание решения Совета'),
    [ExamStatus.SovietProtocolSignedByMembers as string]: new ColorStatus(Color.Default, 'Подписание решения Совета'),
    [ExamStatus.SovietProtocolSignedByChairman as string]: new ColorStatus(Color.Success, 'Утвержден'),
};


export enum ExamApplicationStatus {
    Draft = 'draft',
    InReview = 'inReview',
    CorrectionsRequired = 'correctionsRequired',
    PaymentRequired = 'paymentRequired',
    Canceled = 'canceled',
    Paid = 'paid',
    AdmittedToExam = 'admittedToExam',
    IsPassing = 'isPassing',
    Absent = 'absent',
    NotPassed = 'notPassed',
    Passed = 'passed',
    WaitingForOnlineAccepting = 'waitingForOnlineAccepting',
    HaveNotOnlineAuth = 'haveNotOnlineAuth',
}

export const MappedExamApplicationStatuses = {
    [ExamApplicationStatus.Draft as string]: new ColorStatus(Color.Primary, 'Черновик'),
    [ExamApplicationStatus.InReview as string]: new ColorStatus(Color.Default, 'На рассмотрении'),
    [ExamApplicationStatus.CorrectionsRequired as string]: new ColorStatus(Color.Red, 'Требуются исправления'),
    [ExamApplicationStatus.PaymentRequired as string]: new ColorStatus(Color.Default, 'Одобрена, требуется оплата'),
    [ExamApplicationStatus.Canceled as string]: new ColorStatus(Color.Red, 'Отменен'),
    [ExamApplicationStatus.Paid as string]: new ColorStatus(Color.Default, 'Запись подтверждена'),
    [ExamApplicationStatus.AdmittedToExam as string]: new ColorStatus(Color.Success, 'Допущен к экзамену'),
    [ExamApplicationStatus.IsPassing as string]: new ColorStatus(Color.Default, 'Идет сдача'),
    [ExamApplicationStatus.Absent as string]: new ColorStatus(Color.Red, 'Неявка'),
    [ExamApplicationStatus.NotPassed as string]: new ColorStatus(Color.Red, 'Не сдан'),
    [ExamApplicationStatus.Passed as string]: new ColorStatus(Color.Success, 'Сдан'),
    [ExamApplicationStatus.WaitingForOnlineAccepting as string]: new ColorStatus(Color.Orange, 'Ожидает допуска'),
    [ExamApplicationStatus.HaveNotOnlineAuth as string]: new ColorStatus(Color.Default, 'Нет авторизации'),
};

export enum ExamSessionStatus {
    Active = 'active',
    Completed = 'completed',
}

export enum ExamSessionReadyStatuses {
    WaitingForStart = 'waitingForStart',
    ExamIsPassing = 'examIsPassing',
    TheoreticalExamIsPassingAndSessionStarted = 'theoreticalExamIsPassingAndSessionStarted',
    ExamSessionTimeout = 'examSessionTimeout',
    PracticalExamIsPassingAndSessionStarted = 'practicalExamIsPassingAndSessionStarted',
    ExamFinished = 'examFinished',
    SessionFinished = 'sessionFinished',
}

export const MappedExamSessionReadyStatuses = {
    [ExamSessionReadyStatuses.WaitingForStart as string]: new ColorStatus(Color.Default, 'Ожидает начала'),
    [ExamSessionReadyStatuses.ExamIsPassing as string]: new ColorStatus(Color.Default, 'Идет сдача'),
    [ExamSessionReadyStatuses.TheoreticalExamIsPassingAndSessionStarted as string]: new ColorStatus(Color.Default, 'Идет сдача теоретической части экзамена'),
    [ExamSessionReadyStatuses.ExamSessionTimeout as string]: new ColorStatus(Color.Default, 'Перерыв'),
    [ExamSessionReadyStatuses.PracticalExamIsPassingAndSessionStarted as string]: new ColorStatus(Color.Default, 'Идет сдача практической части экзамена'),
    [ExamSessionReadyStatuses.ExamFinished as string]: new ColorStatus(Color.Default, 'Экзамен завершен'),
    [ExamSessionReadyStatuses.SessionFinished as string]: new ColorStatus(Color.Default, 'Сессия завершена'),
};

export enum AppType {
    Applicant = 'applicant',
    Qec = 'qec',
    Ec = 'ec',
    Spkfr = 'spkfr',
    Exam = 'exam',
    Expert = 'expert'
}

export enum ExamType {
    Intramural = 'intramural',
    Recertification = 'recertification',
    Online = 'online',
}

export enum DocumentType {
    Other = 'other',
    IdentityDoc = 'identityDoc',
    SecondaryEducationConfirmation = 'secondaryEducationConfirmation',
    HigherEducationConfirmation = 'higherEducationConfirmation',
    WorkExperienceConfirmation = 'workExperienceConfirmation',
    ContinuingEducationConfirmation = 'continuingEducationConfirmation',
    CertificateForExchange = 'certificateForExchange',
    NoCriminalRecord = 'noCriminalRecord',
    QualificationCertificate = 'qualificationCertificate',
    ConsentToProcessingPersonalData = 'consentToProcessingPersonalData',
}

export enum IdentityDocType {
    Passport = 'passport',
    Other = 'other',
}

export enum Sex {
    Male = 'male',
    Female = 'female',
}

export enum FilteredExamStatus {
    AwaitingExpertConfirmation = 'awaitingExpertConfirmation',
    IsApplying = 'isApplying',
    ApplyingFinished = 'applyingFinished',
    IsPassing = 'isPassing',
    Finished = 'finished',
    FinalizedResults = 'finalizedResults',
    NokProtocolSigned = 'nokProtocolSigned',
    AkProtocolSigned = 'akProtocolSigned',
    Processed = 'processed',
    Canceled = 'canceled',
}

export const MappedExamTypes = {
    [ExamType.Online as string]: new ColorStatus(Color.Default, 'Онлайн'),
    [ExamType.Recertification as string]: new ColorStatus(Color.Default, 'Признание'),
    [ExamType.Intramural as string]: new ColorStatus(Color.Default, 'Очный'),
};

export enum PracticalQuestionType {
    OpenAnswer = 'openAnswer',
    Essay = 'essay',
    ManualCheckTabular = 'manualCheckTabular',
    AutoCheckTabular = 'autoCheckTabular',
    Offline = 'offline',
}

export enum TheoreticalQuestionType {
    MultipleChoice = 'multipleChoice',
    Matching = 'matching',
    OpenAnswer = 'openAnswer',
    Ordering = 'ordering',
}

export enum ExamPartType {
    Theoretical = 'theoretical',
    Practical = 'practical',
}
